import React, { useState } from 'react';
import { supabase } from '../../api/supabase';

/**
 * Prompts for a staff void PIN. Returns the matching staff member's name on success.
 * Any staff member's void_passcode works (not the admin action_passcode).
 */
export function useVoidPasscode() {
  const [state, setState] = useState(null); // { resolve, reject }
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);

  function prompt() {
    return new Promise((resolve, reject) => {
      setInput('');
      setError('');
      setState({ resolve, reject });
    });
  }

  async function handleConfirm() {
    if (!input.trim()) { setError('Enter your PIN.'); return; }
    setChecking(true);
    const { data } = await supabase.from('staff')
      .select('id, display_name')
      .eq('void_passcode', input.trim())
      .limit(1);
    setChecking(false);
    if (data?.length) {
      const staffName = data[0].display_name;
      setState(null);
      state.resolve(staffName);
    } else {
      setError('Incorrect PIN.');
    }
  }

  function handleCancel() {
    setState(null);
    state?.reject(new Error('cancelled'));
  }

  const Modal = state ? (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: 10, padding: 28, width: 360, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Enter Your Void PIN</div>
        <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
          Enter your personal void PIN to cancel this document. This action will be recorded under your name.
        </div>
        <input
          className="form-input"
          type="password"
          placeholder="Enter your PIN…"
          value={input}
          autoFocus
          onChange={e => { setInput(e.target.value); setError(''); }}
          onKeyDown={e => e.key === 'Enter' && handleConfirm()}
          style={{ marginBottom: 8 }}
        />
        {error && <div style={{ color: '#ef4444', fontSize: 13, marginBottom: 8 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
          <button className="btn btn-danger" onClick={handleConfirm} disabled={checking}>
            {checking ? 'Checking…' : 'Void'}
          </button>
          <button className="btn btn-secondary" onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </div>
  ) : null;

  return { prompt, VoidPasscodeModal: Modal };
}
